import { contactPersonSectionValidationMap } from './sections/contactPersonSection/validations';
import { legalRepresentativesSectionValidationMap } from './sections/legalRepresentativesSection/validations';

export const hausbankPersonalDataFieldValidation = {
  ...contactPersonSectionValidationMap,
  ...legalRepresentativesSectionValidationMap,
};
